import FetchWrapper from '@mv-submodules/inplant-coreadapter-fe/functions/fetch-wrapper'

export const API = () => FetchWrapper.getInstance('user')
export const APIModel = () =>   FetchWrapper.getInstance('model')

export { fetchData, fetchSingleData, fetchSchema } from './user'
